import { Component } from '@angular/core';

import { VERSION } from '../_constants/constants';

@Component({
  selector: 'site-footer',
  templateUrl: './site-footer.component.html',
})
export class SiteFooterComponent {
  
  version = VERSION.CURRENT;

  constructor() {
    
  }
}



// WEBPACK FOOTER //
// ./src/app/site-footer/site-footer.component.ts